import React, { useEffect, useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { getQueryString, push, removeParam, setParam } from "api/search/filterUrlMaker";
import { _t } from "app/i18n/i18n";
import { SearchButton } from "components/SearchBar/SearchButton";
import { useDebounce } from "../../../lib/hooks/useDebounce";

export const AnalystSearchBox = () => {
  const [filterValue, setFilterValue] = useState("");
  const debouncedValue = useDebounce(filterValue, 500);

  useEffect(() => {
    const url = removeParam("speciality");
    push(setParam("q", debouncedValue.trim(), url))
  }, [debouncedValue]);

  const onFilterChange = (e) => {
    setFilterValue(e.target.value);
  };

  return (
    <InputGroup size="sm">
      <Form.Control
        as="input"
        type="search"
        onChange={onFilterChange}
        name="q"
        defaultValue={getQueryString().q}
        size="sm"
        placeholder={_t("Search")}
        className="ml-auto maxw-250"
      />
      <InputGroup.Append>
        <SearchButton disabled/>
      </InputGroup.Append>
    </InputGroup>
  );
}
